module.exports = __webpack_public_path__ + "assets/img/Type BS (9).4af985d5.jpg";